import { COMMAND_PALETTE_ISSUE_ACTIONS } from '../constants.tsx';

export const getCommandPaletteIssueActionsHeader = (issueKey: string | undefined) =>
	`${COMMAND_PALETTE_ISSUE_ACTIONS}-${issueKey || ''}`;
